import { render, staticRenderFns } from "./MobileAppOnline.vue?vue&type=template&id=97efc7b8&scoped=true&"
import script from "./MobileAppOnline.vue?vue&type=script&lang=js&"
export * from "./MobileAppOnline.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "97efc7b8",
  null
  
)

export default component.exports